<Link href={`mailto:${value}`} class="block">{value || ''}</Link>

<script>
  import { Link } from 'carbon-components-svelte'

  export let value
</script>
